// extracted by mini-css-extract-plugin
export default {"DomainActionsButton":"DomainActions_DomainActionsButton__CxAzi","UpdateButtons":"DomainActions_UpdateButtons__IRohG"};